import { moduleIcon, useModuleCatalog } from "@/lib/modules";

export function LandingModules() {
  const catalog = useModuleCatalog();
  return (
    <section className="mx-auto max-w-7xl px-5 sm:px-8 py-20">
      <p className="eyebrow mb-2">Tudo em um só sistema</p>
      <h2 className="text-3xl sm:text-4xl font-bold mb-10 max-w-2xl">Para alimentação, varejo e serviços.</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="landing-modules">
        {catalog.map((m, i) => {
          const Icon = moduleIcon(m.id);
          return (
            <div key={m.id} className="card-surface card-hover p-5 fade-up" style={{ animationDelay: `${i * 30}ms` }} data-testid={`landing-module-${m.id}`}>
              <Icon className="h-6 w-6 text-primary mb-3" />
              <p className="font-semibold">{m.label}</p>
              {m.description && <p className="text-sm text-muted-foreground mt-1">{m.description}</p>}
            </div>
          );
        })}
      </div>
    </section>
  );
}
